import React from "react";
import type { Blocker } from "react-router-dom";

// component
import { Icon } from "@trussworks/react-uswds";
import {
  Dialog,
  DialogContent,
  DialogHeading,
  IconButton,
  Button,
} from "components/LibraryComponents/Components";

// styles
import styles from "./ProfileEditDialog.module.scss";

type FeedbackDialogProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  blocker: Blocker;
};

export default function ProfileEditDialog(props: FeedbackDialogProps) {

  return (
    <Dialog open={props.open} onOpenChange={props.setOpen}>
      <DialogContent
        className={styles["warning-dialog-root"]}
        hasBackdrop
        lockScroll
      >
        <div className={styles["warning-dialog-body"]}>
          <div className={styles["header"]}>
            <DialogHeading className={styles["heading"]}>
              Leave this page?
            </DialogHeading>
            <IconButton
              type="button"
              Icon={<Icon.Close aria-hidden="true" />}
              size="sm"
              onClick={() => {
                props.setOpen(false)
                if (props.blocker.reset) { props.blocker.reset() }; // only fire if reset is available. May not be if hash is changed manually
              }}
              aria-label="Close dialog"
            />
          </div>

          <div className={styles["warning-content"]}>
            <p className={styles["desc"]}>
              Your unsaved changes will be lost if you leave. Click the "Save changes" in each section to update your profile.
            </p>

          </div>
        </div>

        <div className={styles["warning-dialog-footer"]}>
          <Button
            type="button"
            className={styles["btn-leave-page"]}
            aria-label="leave page"
            onClick={() => {
              props.blocker.proceed();
              props.setOpen(false)
            }}
          >
            Leave page
          </Button>
          <Button
            type="button"
            id={"btn-keep-editing"}
            className={styles["btn-keep-editing"]}
            aria-label="Keep editing"
            onClick={() => {
              props.setOpen(false)
            }}
            autoFocus={true}
          >
            Keep editing
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
